import React, { useState, useEffect } from "react";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import { baseApiUrl } from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const MembreBureauAdmin = () => {
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [telephone, setTelephone] = useState("");
  const [poste, setPoste] = useState("");
  const [image, setImage] = useState("");
  const [membres, setMembres] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [viewingMembre, setViewingMembre] = useState(null);
  const [editingMembre, setEditingMembre] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteMembre, setDeleteMembre] = useState(null);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "...";
      }
      return text;
    } else {
      return "";
    }
  };

  const fetchMembres = async () => {
    try {
      const response = await baseApiUrl.get("/membre-bureau");

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = response.data;

      if (!data || data.length === 0) {
        console.warn("Aucun membre trouvé.");
      }

      setMembres(data);
    } catch (error) {
      console.error(
        "Erreur lors du chargement des membres:",
        error.message || error
      );
      openNotificationWithIcon(
        "error",
        "Erreur lors de la récupération des membres du bureau."
      );
    }
  };

  useEffect(() => {
    fetchMembres();
  }, []);

  const handleAddMembre = async (e) => {
    e.preventDefault();

    if (!nom || !prenom || !poste) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    try {
      const formData = new FormData();

      // Création de l'objet membreBureau
      const membreData = {
        nom,
        prenom,
        telephone,
        poste,
      };

     // Dans handleAddMembre
formData.append("image", image);
formData.append("membreBureau", new Blob([JSON.stringify(membreData)], {
  type: "application/json"
}));

      // FormData complète avec l'objet JSON
      const fullData = {
        membreBureau: membreData,
        image: image, // ou null si pas d'image
      };

      // Effectuer l'appel API avec FormData
      const response = await baseApiUrl.post("/membre-bureau/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const newMembre = response.data;

      console.log("Réponse API :", newMembre);

      setMembres([newMembre, ...membres]);

      openNotificationWithIcon("success", "Membre du bureau ajouté avec succès.");
      fetchMembres();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout du membre.");
      console.error("Erreur détectée :", error.response?.data || error.message || error);
    }

    resetForm();
  };


  const handleEditMembre = async (e) => {
    e.preventDefault();

    if (!editingMembre) {
      openNotificationWithIcon("error", "Aucun membre sélectionné pour la modification.");
      return;
    }

    if (!nom || !prenom || !poste) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    try {
      const formData = new FormData();

      // Création de l'objet membreBureau (exactement comme dans handleAddMembre)
      const membreData = {
        nom,
        prenom,
        telephone,
        poste,
      };

      // FormData pour l'image et les données du membre (comme dans handleAddMembre)
      if (image instanceof File) {
        formData.append("image", image);
      }

      // Ajout du membre sous la clé "membreBureau" (comme dans handleAddMembre)
      formData.append("membreBureau", new Blob([JSON.stringify(membreData)], {
        type: "application/json"
      }));

      const response = await baseApiUrl.put(`/membre-bureau/modifier/${editingMembre.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const updatedMembre = response.data;
      console.log("Membre mis à jour:", updatedMembre);

      setMembres(
        membres.map((membre) => (membre.id === updatedMembre.id ? updatedMembre : membre))
      );

      openNotificationWithIcon("success", "Membre du bureau modifié avec succès.");
      setIsEditModalVisible(false);
      await fetchMembres(); // Attendez que les données soient rechargées
    } catch (error) {
      console.error("Erreur lors de la modification du membre:", error);
      console.error("Détails:", error.response?.data);
      openNotificationWithIcon("error", "Erreur lors de la modification du membre.");
    }

    resetForm();
  };

  const handleEdit = (membre) => {
    setViewingMembre(membre);
    setEditingMembre(membre);
    setNom(membre.nom);
    setPrenom(membre.prenom);
    setTelephone(membre.telephone);
    setPoste(membre.poste);
    setImage(null); // Ne pas définir l'image existante

    setIsEditModalVisible(true);
  };

  const handleDeleteConfirm = (membre) => {
    setDeleteMembre(membre);
    setDeleteModalVisible(true);
  };

  const handleDelete = async (idMembre) => {
    try {
      const response = await baseApiUrl.delete(`/membre-bureau/supprimer/${idMembre}`);

      if (response.status !== 200 && response.status !== 204) {
        console.error(`Statut inattendu : ${response.status}`);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      setMembres((prevMembres) =>
        prevMembres.filter((membre) => membre.id !== idMembre)
      );

      setDeleteModalVisible(false);
      setDeleteMembre(null);

      openNotificationWithIcon("success", "Membre du bureau supprimé avec succès.");
    } catch (error) {
      console.error("Erreur lors de la suppression :", error.message || error);
      openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de la suppression du membre."
      );
    }
  };



  const resetForm = () => {
    setIsEditModalVisible(false);
    setIsAddModalVisible(false);
    setIsViewModalVisible(false);
    setNom("");
    setPrenom("");
    setTelephone("");
    setPoste("");
    setImage("");
    setEditingMembre(null);
  };

  const handleView = (membre) => {
    setViewingMembre(membre);
    setIsViewModalVisible(true);
  };

  const filteredMembres = membres.filter((membre) => {
    const nomComplet = `${membre.nom} ${membre.prenom}`.toLowerCase();
    const posteSearch = membre.poste && membre.poste.toLowerCase().includes(searchTerm.toLowerCase());
    return nomComplet.includes(searchTerm.toLowerCase()) || posteSearch;
  });

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Membres du Bureau</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom ou poste"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                  type="success"
                  onClick={() => {
                    resetForm();
                    setIsAddModalVisible(true);
                  }}
                  className="float-end mt-2 btn-success"
                >
                 <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                          Ajouter
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              {
                title: "Nom",
                dataIndex: "nom",
                key: "nom",
                render: (text) => truncateText(text, 6),
              },
              {
                title: "Prénom",
                dataIndex: "prenom",
                key: "prenom",
                render: (text) => truncateText(text, 6),
              },
              {
                title: "Téléphone",
                dataIndex: "telephone",
                key: "telephone",
              },
              {
                title: "Poste",
                dataIndex: "poste",
                key: "poste",
                render: (text) => truncateText(text, 6),
              },

              {
                title: "Photo",
                dataIndex: "image",
                key: "image",
                render: (imageName, record) => {
                  if (imageName) {
                    const imageUrl = baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                    return (
                      <img
                        src={imageUrl}
                        alt="membre"
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    );
                  } else {
                    // Avatar par défaut
                    return (
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "20px",
                          color: "#555",
                        }}
                      >
                        {/* Afficher les initiales */}
                        {record.nom ? record.nom.charAt(0).toUpperCase() : ""}
                        {record.prenom ? record.prenom.charAt(0).toUpperCase() : ""}
                      </div>
                    );
                  }
                },
              },
              {
                key: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => {
                        resetForm();
                        handleView(record);
                      }}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => {
                        resetForm();
                        handleEdit(record);
                      }}
                    >
                      Modifier
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },
            ]}
            dataSource={filteredMembres}
          />

          {/* Modal d'ajout de membre */}
          <Modal
            title="Ajouter un membre du bureau"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            width={800}
            footer={null}
          >
            <form onSubmit={handleAddMembre}>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Prénom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={prenom}
                      onChange={(e) => setPrenom(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Téléphone</label>
                    <input
                      type="text"
                      className="form-control"
                      value={telephone}
                      onChange={(e) => setTelephone(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Poste</label>
                    <input
                      type="text"
                      className="form-control"
                      value={poste}
                      onChange={(e) => setPoste(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Photo du membre</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleImageChange}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary"
                  >
                    Créer
                  </button>
                </div>
              </div>
            </form>
          </Modal>

          {/* Modal de modification de membre */}
          <Modal
            title="Modifier un membre du bureau"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            width={800}
            footer={null}
          >
            <form onSubmit={handleEditMembre}>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Prénom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={prenom}
                      onChange={(e) => setPrenom(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Téléphone</label>
                    <input
                      type="text"
                      className="form-control"
                      value={telephone}
                      onChange={(e) => setTelephone(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Poste</label>
                    <input
                      type="text"
                      className="form-control"
                      value={poste}
                      onChange={(e) => setPoste(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Photo du membre</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleImageChange}
                    />
                  </div>
                </div>
                {editingMembre && editingMembre.image && (
                  <div className="col-sm-6 col-12">
                    <div className="form-group">
                      <label>Photo actuelle</label>
                      <div>
                        <img
                          src={`${baseApiUrl.defaults.baseURL}/image/${editingMembre.image}`}
                          alt="membre"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="row mt-3">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary"
                  >
                    Mettre à jour
                  </button>
                </div>
              </div>
            </form>
          </Modal>

          {/* Modal de confirmation de suppression */}
          <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onCancel={() => setDeleteModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setDeleteModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                danger
                onClick={() => handleDelete(deleteMembre.id)}
              >
                Supprimer
              </Button>,
            ]}
          >
            <p>
              Êtes-vous sûr de vouloir supprimer ce membre du bureau ? Cette action est
              irréversible.
            </p>
          </Modal>

          {/* Modal pour afficher les détails */}
          <Modal
            title="Détails du membre"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setIsViewModalVisible(false)}>
                Fermer
              </Button>,
            ]}
          >
            {viewingMembre && (
              <div>
                <div className="text-center mb-4">
                  {viewingMembre.image ? (
                    <img
                      src={`${baseApiUrl.defaults.baseURL}/image/${viewingMembre.image}`}
                      alt="membre"
                      style={{
                        width: "150px",
                        height: "150px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "150px",
                        height: "150px",
                        borderRadius: "50%",
                        backgroundColor: "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "50px",
                        color: "#555",
                        margin: "0 auto",
                      }}
                    >
                      {viewingMembre.nom ? viewingMembre.nom.charAt(0).toUpperCase() : ""}
                      {viewingMembre.prenom ? viewingMembre.prenom.charAt(0).toUpperCase() : ""}
                    </div>
                  )}
                </div>
                <p>
                  <strong>Nom:</strong> {viewingMembre.nom}
                </p>
                <p>
                  <strong>Prénom:</strong> {viewingMembre.prenom}
                </p>
                <p>
                  <strong>Téléphone:</strong> {viewingMembre.telephone || "Non renseigné"}
                </p>
                <p>
                  <strong>Poste:</strong> {viewingMembre.poste}
                </p>
                <p>
                  <strong>Statut:</strong> {viewingMembre.actif ? "Actif" : "Inactif"}
                </p>
              </div>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
};

export default MembreBureauAdmin;
